// @ts-nocheck: converted from JS

import Maintenance from './Maintenance';

export default Maintenance;
